import { deleteRequest, getRequest } from "../../helpers/request.js";

export const TYPES = {
  API_REQUEST: "API_REQUEST",
  API_ERROR: "API_ERROR",
  API_SUCCESS: "API_SUCCESS",
  CLEAR_ERROR: "CLEAR_ERROR",

  LIST_MIGRATION_CONTENT_SUCCESS: "LIST_MIGRATION_CONTENT_SUCCESS",

  DELETE_MIGRATION_CONTENT: "DELETE_MIGRATION_CONTENT",
};
export const clearError = () => async (dispatch) => {
  dispatch({ type: TYPES.CLEAR_ERROR });
};

export const apiResponse = (error, msg) => async (dispatch) => {
  dispatch({ type: error ? TYPES.API_ERROR : TYPES.API_SUCCESS, data: msg });
};

export const migrationContentsList = (initialDate, finalDate) => async (dispatch) => {
  dispatch({ type: TYPES.API_REQUEST });
  try {
    // Construct query parameters for the date range
    const queryParams = `?startDate=${initialDate}&endDate=${finalDate}`;

    const { data } = await getRequest(`migration-contents${queryParams}`, {
      headers: {
        "x-access-token": localStorage.getItem("token"),
        "x-refresh-token": localStorage.getItem("refreshToken"),
        changeOrigin: true,
      },
    });

    if (data.isSuccess) {
      dispatch({
        type: TYPES.LIST_MIGRATION_CONTENT_SUCCESS,
        data: data.migrationContents,
      });
    } else {
      dispatch({ type: TYPES.API_ERROR, data: data.msg });
    }
  } catch (error) {
    console.log(error);
    dispatch({ type: TYPES.API_ERROR, data: JSON.stringify(error) });
  }
};

export const deleteMigrationContent = (_id) => async (dispatch) => {
  dispatch({ type: TYPES.API_REQUEST });

  try {
    const { data } = await deleteRequest(`migration-contents/${_id}`, {
      headers: {
        "x-access-token": localStorage.getItem("token"),
        "x-refresh-token": localStorage.getItem("refreshToken"),
        changeOrigin: true,
      },
    });
    if (data.isSuccess) {
      dispatch({ type: TYPES.DELETE_MIGRATION_CONTENT, data: _id });
    } else {
      console.error(data.msg);
      dispatch({ type: TYPES.API_ERROR, data: data.msg });
    }
  } catch (error) {
    console.log(error);
    dispatch({ type: TYPES.API_ERROR, data: JSON.stringify(error) });
  }
};
